import { useState } from "react";
import { Radar, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { qualApi, qualErr, CARD, BTN } from "./esriQualApi";

function ProbeResult({ probe }) {
  if (!probe) return <div className="font-mono text-[10px] text-[#525252]">Aucune sonde exécutée.</div>;
  return (
    <div data-testid="esri-probe-result" data-ok={probe.ok ? "1" : "0"} className="space-y-1 font-mono text-[10px]">
      <div className={probe.ok ? "text-[#22C55E]" : "text-[#EF4444]"}>SONDE {probe.ok ? "RÉUSSIE" : "EN ÉCHEC"} · {String(probe.at)} · liée à la clé actuelle : {probe.bound_to_current_key ? "OUI" : "NON"}</div>
      {Object.entries(probe.styles || {}).map(([k, s]) => (
        <div key={k} data-testid={`esri-probe-style-${k}`} className="text-[#A3A3A3]">
          {k.toUpperCase()} ({s.esri_style}) → HTTP {s.http_status ?? s.upstream?.http_status ?? "—"} {s.tile_rows ? `· ${s.tile_rows}×${s.tile_cols} ${s.format} · EPSG:${s.wkid} · z${s.min_zoom}-${s.max_zoom}` : ""} {s.skycore_code || ""}
          {s.copyright_text && <div className="text-[#525252]">ATTRIBUTION : {s.copyright_text}</div>}
        </div>
      ))}
      {probe.diagnostic && (
        <div data-testid="esri-probe-diagnostic" className="border border-[#EF4444]/40 bg-[#EF4444]/10 rounded-sm p-2 text-[#FCA5A5]">
          <div>HTTP {probe.diagnostic.http_status} · code Esri {probe.diagnostic.esri_code ?? "—"} · {probe.diagnostic.esri_message || ""}</div>
          {probe.diagnostic.lines.map((l) => <div key={l}>{l}</div>)}
        </div>
      )}
    </div>
  );
}

export function ProbeCard({ q, config, onChange }) {
  const [busy, setBusy] = useState(false);
  const canProbe = ["CONFIGURATION_READY", "QUALIFICATION_FAILED"].includes(q.state) && !(q.probe && q.probe.bound_to_current_key && q.probe.ok);
  const run = async () => {
    if (!window.confirm(`Tester la connexion Esri : 2 requêtes RÉELLES de métadonnées (budget ${q.metadata_budget.used}/${q.metadata_budget.max}). Continuer ?`)) return;
    setBusy(true);
    try { const { data } = await qualApi.probe(); data.ok ? toast.success("Connexion Esri réussie") : toast.error("Connexion Esri en échec — voir diagnostic"); onChange(); }
    catch (e) { toast.error(qualErr(e)); }
    finally { setBusy(false); }
  };
  return (
    <section data-testid="esri-probe-card" className={CARD}>
      <h2 className="font-chivo text-base md:text-lg font-black uppercase tracking-tight flex items-center gap-2"><Radar size={16} /> 2 · Tester la connexion Esri</h2>
      <div data-testid="esri-metadata-budget" className="font-mono text-[10px] text-[#A3A3A3]">BUDGET MÉTADONNÉES : {q.metadata_budget.used}/{q.metadata_budget.max} · CAMPAGNE {q.campaign_id}</div>
      <button data-testid="esri-probe-btn" onClick={run} disabled={!canProbe || busy} className={`${BTN} bg-[#F59E0B]/15 border-[#F59E0B]/50 text-[#F59E0B]`}>
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Radar size={12} />} Tester la connexion Esri
      </button>
      <ProbeResult probe={q.probe} />
      {config.attribution_verified && <div data-testid="esri-attribution-verified" className="font-mono text-[10px] text-[#22C55E] flex items-center gap-1"><ShieldCheck size={12} /> ATTRIBUTION RÉELLE ENREGISTRÉE (affichée sur chaque tuile)</div>}
    </section>
  );
}
